import { render, staticRenderFns } from "./goodEvaluateStatistice.vue?vue&type=template&id=12055621&scoped=true"
import script from "./goodEvaluateStatistice.vue?vue&type=script&lang=js"
export * from "./goodEvaluateStatistice.vue?vue&type=script&lang=js"
import style0 from "./goodEvaluateStatistice.vue?vue&type=style&index=0&id=12055621&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12055621",
  null
  
)

export default component.exports